import React from "react";
import { Star } from "lucide-react";
import dummyImage from "../../images/background/dummyProfilebg.png";
import { aiSkills } from "../../constants/constants";

const MentorCard = ({ mentor, onAppointment, userType }) => {
  const priceText = mentor.mentorMeeting ? 
    Object.entries(mentor.mentorMeeting)
      .filter(([_, price]) => price)
      .map(([duration, price]) => `$${price}`)
      .join(" – ") || "Not set" : "Not set";
  
  const isPriceAvailable = priceText !== "Not set";
  const rating = Math.min(5, Math.max(1, Math.round(mentor.reviews?.totalReviews / 20) + 4.5));
  const sessions = Math.floor(Math.random() * 200) + 50;

  return (
    <div
      className="bg-gray-50 border border-gray-300 rounded-xl p-3 hover:shadow-lg transition-shadow cursor-pointer"
      onClick={() => {
        if (userType === "mentor") {
          window.location.href = `/dashboard/book-appointment/${mentor.userId}`;
        } else if (!(userType === "user" && !isPriceAvailable)) {
          onAppointment(mentor.userId);
        }
      }}
    >
      {/* Profile Picture and Name/Title */}
      <div className="flex items-center gap-4 mb-4">
        <div className="border border-gray-200 rounded-full flex items-center justify-center flex-shrink-0">
          <img
            src={mentor.profileImage || dummyImage}
            alt={`${mentor.firstName} ${mentor.lastName}`}
            className="w-14 h-14 rounded-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-bold text-gray-900 mb-1">
            {mentor.firstName} {mentor.lastName}
          </h3>
          <p className="text-gray-600 text-xs">
            {mentor.currentJobOccupation || "AI Professional"} at {mentor.company || "Tech Company"}
          </p>
        </div>
      </div>

      {/* Rating and Sessions */}
      <div className="flex items-center gap-2 mb-4">
        <Star className="w-4 h-4 text-yellow-400 fill-current" />
        <span className="text-sm font-semibold text-gray-900">{rating.toFixed(1)}</span>
        <span className="text-gray-500 text-sm">({sessions} sessions)</span>
      </div>

      {/* Skills Tags */}
      <div className="flex flex-wrap gap-2 mb-3">
        {mentor.aiSkills?.slice(0, 3).map((skill, index) => (
          <span
            key={index}
            className="px-3 py-1 bg-purple-100 text-purple-700 text-xs font-medium rounded-full"
          >
            {aiSkills.find(s => s.value === skill)?.label || skill}
          </span>
        ))}
        {mentor.aiSkills?.length > 3 && (
          <span className="px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full">
            +{mentor.aiSkills.length - 3}
          </span>
        )}
      </div>

      {/* Action Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          if (userType === "mentor") {
            // For mentors, navigate to view profile
            window.location.href = `/dashboard/book-appointment/${mentor.userId}`;
          } else if (!(userType === "user" && !isPriceAvailable)) {
            onAppointment(mentor.userId);
          }
        }}
        disabled={userType === "user" && !isPriceAvailable}
        className={`w-full py-1 px-1 rounded-lg font-medium text-sm transition-colors ${
          userType === "user" && !isPriceAvailable
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : userType === "mentor"
            ? "bg-white text-black border border-gray-400 hover:bg-gray-50"
            : "text-black border border-gray-400 hover:bg-gray-100"
        }`}
      >
        {userType === "mentor" ? "View Profile" : "Book an Appointment"}
      </button>
    </div>
  );
};

export default MentorCard; 